export const PLANNER_ENABLED = true;
export const JOURNEYS_ENABLED = false;
